import { resolveMediaUrl } from "../lib/api";

// Shared avatar: shows the user's uploaded picture, else a letter fallback.
export default function Avatar({ user, size = 36, rounded = "rounded-full", className = "", testid }) {
  const letter = (user?.name || user?.email || "U").charAt(0).toUpperCase();
  const src = user?.avatar_url ? resolveMediaUrl(user.avatar_url) : null;
  const style = { width: size, height: size };
  if (src) {
    return (
      <img
        src={src} alt={user?.name || "Profile"} style={style}
        className={`${rounded} object-cover ${className}`}
        data-testid={testid}
      />
    );
  }
  return (
    <div
      style={{ ...style, fontSize: Math.round(size * 0.42) }}
      className={`flex items-center justify-center font-bold text-[var(--accent-contrast)] bg-[var(--accent)] ${rounded} ${className}`}
      data-testid={testid}
    >
      {letter}
    </div>
  );
}
